import React,{useState, useEffect, useRef} from 'react';
import axios from 'axios';
import {databaseUrl} from '../../server/server.js';
import { databaseNoport } from '../../server/server.js';
// import Ordermenu from './ordermenu.js';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Switch from '@mui/material/Switch';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';


//excel
import XLSX from 'xlsx-js-style';  // xlsx-js-style를 사용하기 위해 추가

import MenuItem from '@mui/material/MenuItem';
//import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// ui grid
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import {borders, width} from '@mui/system';
import {
  GridRowsProp,
  GridRowModesModel,
  GridRowModes,
  DataGrid,
  GridColDef,
  GridToolbarContainer,
  GridActionsCellItem,
  GridEventListener,
  GridRowId,
  GridRowModel,
  GridRowEditStopReasons,
  GridSlots,
} from '@mui/x-data-grid';
import {
  randomCreatedDate,
  randomTraderName,
  randomId,
  randomArrayItem,
} from '@mui/x-data-grid-generator';
import dayjs from 'dayjs';
import axiosInstance from '../../server/axios.js';

let access = localStorage.getItem("accesstoken");
const order_list = [];
const label = { inputProps: { 'aria-label': 'Switch demo' } };

const Order = () => {
  const navigate = useNavigate();
  const [searchTitle, setSearchTitle] = useState('발주처')
//  const [searchString, setSearchString] = useState('')
  const searchString = useRef("");

  const [materialList,setMaterialList] = useState([]);
  const [order_company,setOrder_company] = useState([]);
  const [buy_company,setBuy_company] = useState([]);
  const [deposit_company,setDeposit_company] = useState([]);
  const [deposit_company_ratio,setDeposit_company_ratio] = useState([]);

  //pagination
  const [page, setPage] = useState(1);
  const [orderCount, setOrderCount ] = useState(0);
  const [orderList, setOrderList ] = useState([]);

  const GetInputData = () => {
    useEffect( () => {
      axios.get(`${databaseUrl}/orderboard/order`,{
        headers: {Authorization:`Bearer ${access}`},
    }).then((response)=>{
        const materialList = [];
        const order_company = [];
        const buy_company = [];
        const deposit_company = [];
        const deposit_company_ratio = [];

        for(let i = 0; i < response.data[0].length; i++){
          materialList.push({label:response.data[0][i]['품명']+`| ${response.data[0][i]['품목코드']}`,code:response.data[0][i]['품목코드']});
        }
        for(let i = 0; i < response.data[1].length; i++){
          buy_company.push({label:response.data[1][i]['거래처명']+`| ${response.data[1][i]['코드']}`,code:response.data[1][i]['코드']});
        }
        for(let i = 0; i < response.data[2].length; i++){
          order_company.push({label:response.data[2][i]['거래처명']+`| ${response.data[2][i]['코드']}`,code:response.data[2][i]['코드']});
        }
        for(let i = 0; i < response.data[3].length; i++){
          deposit_company.push(response.data[3][i]['company_code']);
          deposit_company_ratio.push(Number(response.data[3][i]['ratio']));
        }
        setMaterialList([...materialList])
        setOrder_company([...order_company])
        setBuy_company([...buy_company])
        setDeposit_company([...deposit_company])
        setDeposit_company_ratio([...deposit_company_ratio])
    }).catch((error)=>{
      if(error.response?.status === 401){
        alert('You are not login');
        navigate('/SignIn');
      }
      if(error.response?.status === 405){
        const refresh = localStorage.getItem("refreshtoken");
        axios.post(`${databaseUrl}/users/refresh`,{},{
          headers: {Authorization:`Bearer ${refresh}`},
        }).then( (response)=>{
          localStorage.setItem("accesstoken",response.data.accesstoken);
          localStorage.setItem("refreshtoken",response.data.refreshtoken);
  
          window.location.reload();
        }).catch((error) => {alert(error);})
      }
    })
    },[]);
  }
  GetInputData();
/*
  const inputSearch = (event) => {
    setSearchString(event.target.value);
  }
*/
  const handleSearch = (event) => {
    setSearchTitle(event.target.value);
  }
  const SearchOrder = (p) => {
      let searching =searchString.current.value;
      if(searching.length === 0){alert('1 글자 이상 입력해주세요'); return;};
      let string = '';
      switch(searchTitle){
        case '발주처': string='order_company';
        break;
        case '원료명': string='material';
        break;
        case '구매업체': string='purchaser';
        break;
        case '배송': string='delivery';
        break;
        case '비고': string='note';
        break;
      }
      axios.get(`${databaseUrl}/orderboard/ordersearch?column=${string}&search=${searching}&page=${p}&size=${15}`,{
        headers: {Authorization:`Bearer ${access}`},
      }).then((response) => {
        const order = [];
        for(let i = 0; i < response.data.order.length; i++){
          const order_company_text = response.data.order[i].order_company.replace(/:apo:/g,"'");
          const material_text = response.data.order[i].material.replace(/:apo:/g,"'");
          const purchaser_text = response.data.order[i].purchaser.replace(/:apo:/g,"'");
          setOrderCount(Math.ceil(Number(response.data.count)/15));
          order.push({
            id:(response.data.order[i].id),
            inputdate:response.data.order[i].inputdate.substr(5, 5),
            order_company:order_company_text,
            order_company_code:response.data.order[i].order_company_code,
            material:material_text,
            material_code:response.data.order[i].material_code,
            material_weight:Number(response.data.order[i].material_weight),
            material_price:response.data.order[i].material_price,
            deposit:response.data.order[i].deposit === 'O' ? true : false,
            deposit_price: response.data.order[i].deposit_price,
            deposit_day: new Date(response.data.order[i].deposit_day),
            deposit_send: response.data.order[i].deposit_send,
            due_date:new Date(response.data.order[i].due_date),
            statement:new Date(response.data.order[i].statement),
            purchaser:purchaser_text,
            purchaser_code:response.data.order[i].purchaser_code,
            delivery:response.data.order[i].delivery,
            delivery_date:new Date(response.data.order[i].delivery_date),
            result:response.data.order[i].result,
            note:response.data.order[i].note,
          });
        }
        setRows([...order]);
        setOrdersubject(`검색어 [${searching}] 관련 목록  / Total : ${response.data.count} 건`)
      })

  }
  const location = useLocation(); // 추가된 부분
  const orderboardDay = location.state?.data; // 추가된 부분

  const orderdayCheck = new Date();
  const orderdayCheckYear = orderdayCheck.getFullYear();
  const orderdayCheckMonth = orderdayCheck.getMonth() + 1 >= 10 ? orderdayCheck.getMonth()+1 : '0'+(orderdayCheck.getMonth()+1);
  const orderdayCheckDate = orderdayCheck.getDate() < 10 ? '0'+(orderdayCheck.getDate()) : orderdayCheck.getDate();
  
  const holydayArr = [
    '2024-08-15',
    '2024-09-16',
    '2024-09-17',
    '2024-09-18',
    '2024-10-03',
    '2024-10-09',
    '2024-12-25',
    '2025-01-01',
    '2025-01-28',
    '2025-01-29',
    '2025-01-30',
    '2025-03-01',
    '2025-03-03',
    '2025-05-05',
    '2025-05-06',
    '2025-06-06',
    '2025-08-15',
    '2025-10-03',
    '2025-10-05',
    '2025-10-06',
    '2025-10-07',
    '2025-10-09',
    '2025-12-25'
  ];
      
  const getVisitCompanyDay = (_holydayArr,getDays,getDaysNumber,getAfterdays,tomorrow) => {
    const AfterBefore = getDays === 'after' ? +(getAfterdays) : -(getAfterdays);
    const DayList = [];
    for(let i = 1; DayList.length < getDaysNumber; i++){
      const theDay =  tomorrow === '' ? new Date() : new Date(tomorrow);
      const afterDay = new Date(theDay.setDate(theDay.getDate() + i*AfterBefore));
      const dayOfWeek = new Date(afterDay).getDay(); 
      if(dayOfWeek === 0 || dayOfWeek === 6){continue;}
      const year = afterDay.getFullYear();
      const month = afterDay.getMonth()+1 < 10 ? '0'+(afterDay.getMonth()+1) : (afterDay.getMonth()+1);
      const day = afterDay.getDate() < 10 ? '0'+afterDay.getDate() : afterDay.getDate();
      const testHolyday = `${year}-${month}-${day}`;
      if(_holydayArr.indexOf(testHolyday) !== -1){continue;}
      DayList.push(`${year}-${month}-${day}`);
    }
    return DayList;
  }
  const orderDayAfter = getVisitCompanyDay(holydayArr,'after',1,1,'');
  const orderTwodayAfter = getVisitCompanyDay(holydayArr,'after',1,1,orderDayAfter);

  const [today, setToday] = useState(`${orderdayCheckYear}-${orderdayCheckMonth}-${orderdayCheckDate}`);
  const [tomorrow, setTomorrow] = useState(`${orderDayAfter[0]}`);
  const [twodayafter, setTwodayafter] = useState(`${orderTwodayAfter[0]}`);


  const [ordersubject,setOrdersubject] = useState('발주 리스트');
  const [detectedOrder, setDetectedOrder] = useState(0);
  const [manulist, setManulist] = useState("");
  const [materialChange, setMaterialChange] = useState(null ?? 'nodata');
  const [orderChange, setOrderChange] = useState(null ?? 'nodata');
  const [textarea, setTextarea] = useState('');
  const [depositRatio, setDepositRatio] = useState(1);

  const checkdeposit = (newVal) => {
    const isNothing = newVal ?? 'Yes';
    if(isNothing === 'Yes'){
      return setDeposit(false);
    }
    const depositIndex = deposit_company.indexOf(newVal.code);
    if(depositIndex !== -1 ){
      const deposit_Ratio = deposit_company_ratio[depositIndex];
      setDepositRatio(deposit_Ratio);
      setDeposit(true);
    }else{
      setDeposit(false);
    }
    setOrderChange(newVal)
  }
  const changeTextarea = (event) => {
    setTextarea(event.target.value);
  }

  const [buyChange, setBuyChange] = useState(null ?? 'nodata');
  const [weight, setWeight] = useState(0.000);  
  const [price, setPrice] = useState(0);  

  //delivery
  const [delivery, setDelivery] = useState('미정');
  const [deliveryDate, setDeliveryDate] = useState('');

  //deposit part
  const [deposit, setDeposit] = useState(false);
  const [depositPrice, setDepositPrice] = useState(0);
  const [depositDate, setDepositDate] = useState('');

  //handle dilivery
  const handleDilivery = (event) => {
    setDelivery(event.target.value);
  };
  
  // Input value is an empty string by default
  const [materialInputChange, setMaterialInputChange] = useState('');
  const [orderInputChange, setOrderInputChange] = useState('');
  const [buyInputChange, setBuyInputChange] = useState('');


  const handleSubmit = (event) => {
    event.preventDefault();
    if(materialInputChange.trim() === ''){
        return alert('Must Input Material');
    }
    if(orderInputChange.trim() === ''){
        return alert('Must Input Order_Company');
    }
    if(weight <= 0){
      return alert('Input correct weight');
    }
    if(deliveryDate === ''){
      return alert('납기일을 입력해주세용');
    }
    const dateformat = new Date();
    const year = dateformat.getFullYear();
    const month = dateformat.getMonth()+1;
    const day = dateformat.getDate();
    const today = new Date(`${year}-${month}-${day}`);
    const inputDay = new Date(deliveryDate);
    if(today > inputDay){
      return alert('납기일은 오늘 보다 이전이 될수 없습니다');
    }
    const materialArr = materialInputChange.split('|').length === 2 ? materialInputChange.split('|') : [materialInputChange,''];
    const orderArr = orderInputChange.split('|').length === 2 ? orderInputChange.split('|') : [orderInputChange,''] ;
    const buyArr = buyInputChange.split('|').length === 2 ?  buyInputChange.split('|') : [buyInputChange,''];
    const Isdeposit = deposit === true ? 'O' :  'X';
      axios.post(`${databaseUrl}/orderboard/create`,{
        material : materialArr[0].trim(),
        material_code : materialArr[1].trim(),
        order_company : orderArr[0].trim(),
        order_company_code : orderArr[1].trim(),
        buy_company : buyArr[0].trim(),
        buy_company_code : buyArr[1].trim(),
        deposit : Isdeposit,
        price : price,
        depositPrice : depositPrice,
        depositDate : depositDate,
        weight : weight,
        delivery : delivery,
        deliverydate : deliveryDate,
        note : textarea
      },{
        headers: {Authorization:`Bearer ${access}`}
      }).then((response)=>{
        window.location.reload();
        /*
        if(response.data === 'queryOK'){
          materialList.length = 0;
          order_company.length = 0;
          buy_company.length = 0;
          GetInputData();
        }
        */

      })
    setMaterialChange(null);
    setMaterialInputChange('');
    setOrderChange(null);
    setOrderInputChange('');
    setBuyChange(null);
    setBuyInputChange('');
    setDeposit(false);
    setWeight(0.000);
    setPrice(0);
    setDelivery('미정');
    setDeliveryDate('');
    setDepositPrice(0);
    setTextarea('');
    setDepositRatio(1);
    setDetectedOrder(detectedOrder + 2);
  }

  const switchDeposit = (event) => {
    setDeposit(event.target.checked)
  }
  const inputWeight = (event) => {
    setWeight(event.target.value);
  }
  const inputPrice = (event) => {
    const checkinputPrice = Number(event.target.value);
    if(deposit === true){
      const checkWeight = Number(weight);
      setDepositPrice(checkinputPrice*checkWeight*depositRatio*1.1);
    }
    setPrice(checkinputPrice);
  }
  const inputDeliveryDate = (event) => {
    setDeliveryDate(event.target.value)
  }
  const inputDepositPrice = (event) => {
    setDepositPrice(event.target.value)
  }
  const inputDepositDate = (event) => {
    setDepositDate(event.target.value)
  }
  const GetOrderList = () => {
    useEffect(() => {
      axios.get(`${databaseUrl}/orderboard/orderlist?page=${page}&size=${15}`,{
        headers: {Authorization:`Bearer ${access}`},
      }).then((response) => {
        const order = [];
        setOrderCount(Math.ceil(Number(response.data.count)/15));
        for(let i = 0; i < response.data.order.length; i++){
          const order_company_text = response.data.order[i].order_company.replace(/:apo:/g,"'");
          const material_text = response.data.order[i].material.replace(/:apo:/g,"'");
          const purchaser_text = response.data.order[i].purchaser.replace(/:apo:/g,"'");
          order.push({
            id:(response.data.order[i].id),
            inputdate:response.data.order[i].inputdate.substr(5, 5),
            order_company:order_company_text,
            order_company_code:response.data.order[i].order_company_code,
            material:material_text,
            material_code:response.data.order[i].material_code,
            material_weight:Number(response.data.order[i].material_weight),
            material_price:response.data.order[i].material_price,
            deposit:response.data.order[i].deposit === 'O' ? true : false,
            deposit_price: response.data.order[i].deposit_price,
            deposit_day: new Date(response.data.order[i].deposit_day),
            deposit_send: response.data.order[i].deposit_send,
            due_date:new Date(response.data.order[i].due_date),
            statement:new Date(response.data.order[i].statement),
            purchaser:purchaser_text,
            purchaser_code:response.data.order[i].purchaser_code,
            delivery:response.data.order[i].delivery,
            delivery_date:new Date(response.data.order[i].delivery_date),
            result:response.data.order[i].result,
            note:response.data.order[i].note,
          });
        }
        setRows([...order]);
        setOrdersubject('발주 리스트');
      }).catch((error) => {
      })
   },[detectedOrder]);
 }
  GetOrderList(page,10);

  const handleChange = (event, value) => {
    if(searchString.current.value.length === 0 ){
      setDetectedOrder(detectedOrder + 1);
    }else{
      console.log(searchString.current.value.length,value);
      SearchOrder(value);
    }
    setPage(value);
  };
  const windowReload = () => {
    window.location.reload();
  }
  const getTodayOrder = (day) => {
    setRows([]);
    GetTodayOrderList(day,(length)=>{
      setOrdersubject(`오늘 [${day}] 발주 목록  / Total : ${length} 건`)
    }); 
  }
  const getTomorrowOrder = (day) => {
    setRows([]);
    GetTodayOrderList(day,(length)=>{
      setOrdersubject(`내일 [${day}] 발주 목록  / Total : ${length} 건`)
    });
  }
  const GetTodayOrderList = (_day,callback) => {
    axios.get(`${databaseUrl}/orderboard/orderdaylist?day=${_day}`,{
      headers: {Authorization:`Bearer ${access}`},
    }).then((response) => {
      const order = [];
      setOrderCount(1);
      for(let i = 0; i < response.data.order.length; i++){
        const order_company_text = response.data.order[i].order_company.replace(/:apo:/g,"'");
        const material_text = response.data.order[i].material.replace(/:apo:/g,"'");
        const purchaser_text = response.data.order[i].purchaser.replace(/:apo:/g,"'");
        order.push({
          id:Number(response.data.order[i].id),
          inputdate:response.data.order[i].inputdate.substr(5, 5),
          order_company:order_company_text,
          order_company_code:response.data.order[i].order_company_code,
          material:material_text,
          material_code:response.data.order[i].material_code,
          material_weight:Number(response.data.order[i].material_weight),
          material_price:response.data.order[i].material_price,
          deposit:response.data.order[i].deposit === 'O' ? true : false,
          deposit_price: response.data.order[i].deposit_price,
          deposit_day: new Date(response.data.order[i].deposit_day),
          deposit_send: response.data.order[i].deposit_send,
          due_date:new Date(response.data.order[i].due_date),
          statement:new Date(response.data.order[i].statement),
          purchaser:purchaser_text,
          purchaser_code:response.data.order[i].purchaser_code,
          delivery:response.data.order[i].delivery,
          delivery_date:new Date(response.data.order[i].delivery_date),
          result:response.data.order[i].result,
          note:response.data.order[i].note,
        });
      }
      setRowsLength(order.length);
      setRows([...order]);
      callback(order.length);
    })
 }

//const [rows, setRows] = useState(initialRows);
const initialRows = [];
const [rows, setRows] = useState(initialRows);
const [rowsLength, setRowsLength] = useState(null);
const [rowModesModel, setRowModesModel] = useState({});

const handleRowEditStop = (params, event) => { 
  if (params.reason === GridRowEditStopReasons.rowFocusOut) {
    event.defaultMuiPrevented = true;
  }
};
const handleEditClick = (id) => () => {
  setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
};
const handleSaveClick = (id) => () => {
  setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
};
const handleDeleteClick = (id) => () => {
  if(window.confirm(`글 번호 ${id} 삭제하시겠습니까?`)){
    axios.get(`${databaseUrl}/orderboard/orderdelete?id=${id}`,
      {headers: {Authorization:`Bearer ${access}`},}
      ).then((response)=>{
        alert(`번호 ${id} 삭제 됐습니다`);
        setDetectedOrder(detectedOrder + 1);
      })
  }else{
    alert('취소 됐습니다');
  }
};
const handleCancelClick = (id) => () => {
  setRowModesModel({
    ...rowModesModel,
    [id]: { mode: GridRowModes.View, ignoreModifications: true },
  });
  const editedRow = rows.find((row) => row.id === id);
  if (editedRow.isNew) {
    setRows(rows.filter((row) => row.id !== id));
  }
};
const processRowUpdate = (newRow) => {
  const updatedRow = { ...newRow, isNew: false };
  const oldrow = rows.filter( (row) => {return row.id === newRow.id})[0];
  const objectKeyArr = Object.keys(newRow);
  const updateObj = {};
  for(let i = 0; i < objectKeyArr.length; i++){
    if(oldrow[objectKeyArr[i]] !== updatedRow[objectKeyArr[i]]){
      updateObj[objectKeyArr[i]] = updatedRow[objectKeyArr[i]];
    }
  }
  delete updatedRow.isNew;
  const utc_time = updatedRow.delivery_date.getTime() + (updatedRow.delivery_date.getTimezoneOffset()*60*1000);
  axios.post(`${databaseUrl}/orderboard/updateorder`,{
    updaterow : updatedRow,
    updateobj : updateObj
  },{
    headers: {Authorization:`Bearer ${access}`}
  }).then((response)=>{
    //setDetectedOrder(detectedOrder + 1);
  })
  //setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
  return updatedRow;
};

const handleRowModesModelChange = (newRowModesModel) => {
  setRowModesModel(newRowModesModel);
};

const reviewOrder = (orderNumber) => {
  return window.open(`${databaseNoport}/orderreview?id=${orderNumber}`,'targetWindow',
  `toolbar=no,
   location=no,
   top=200,
   left=200,
   status=no,
   menubar=no,
   scrollbars=yes,
   resizable=yes,
   width=1600px,
   height=500px`);
}
const columnList = [
  { field: 'id', 
    headerName: '번호', 
    width: 90, 
    editable: false ,
    renderCell: (params) => { 
      return (
        (params.value+'').indexOf('구') === -1 ? 
        <Button variant="outlined" color="secondary" onClick={()=>reviewOrder(params.value)}>{params.value}</Button> 
        :<div>{params.value}</div>
      );
    },
  },
  { field: 'inputdate', 
    headerName: '접수일', 
    width: 100, 
    editable: false 
  },
  {
    field: 'order_company',
    headerName: '발주처',
    width: 150,
    align: 'left',
    editable: true,
  },
  {
    field: 'material',
    headerName: '품명',
    width: 200,
    align: 'left',
    editable: true,
  },
  {
    field: 'material_weight',
    headerName: '수량',
    width: 100,
    type:'number',
    align:'right',
    editable: true,
  },
  {
    field: 'material_price',
    headerName: '단가',
    width: 100,
    type:'number',
    align:'right',
    editable: true,
  },
  {
    field: 'due_date',
    headerName: '납기요청일',
    type: 'date',
    width: 100,
    align:'center',
    editable: true,
//    valueFormatter: (params) => {return dayjs(params.value).format('MM/DD')},
  },
  {
    field: 'deposit',
    headerName: '선입금',
    width: 80,
    align:'center',
    editable: true,
    renderCell: (params) => {
      return (
        <Switch color='success' checked={params.value}/>
      );
    },
    renderEditCell:(params) => {
      return (
        <Switch color='success' onChange={(e) => {
          // Update the value in the cell
          const updatedValue = e.target.checked;
            params.api.setEditCellValue({
            id: params.id,
            field: params.field,
            value: updatedValue,
          });
        }} checked={params.value}/>
      );
    },
  },
  {
    field: 'deposit_price',
    headerName: '선입 금액',
    width: 100,
    type:'number',
    align:'right',
    editable: true,
  },
  {
    field: 'deposit_day',
    headerName: '입금여부',
    type: 'date',
    width: 100,
    align:'right',
    editable: true,
  },
  {
    field: 'deposit_send',
    headerName: '입금금액',
    width: 100,
    align:'right',
    editable: true,
  },
  {
    field: 'delivery',
    headerName: '배송',
    width: 80,
    align:'center',
    editable: true,
  },
  {
    field: 'delivery_date',
    headerName: '배송일',
    type: 'date',
    width: 120,
    align:'center',
    editable: true,
  },
  {
    field: 'purchaser',
    headerName: '구매업체',
    width: 150,
    align:'left',
    editable: true,
  },
  {
    field: 'statement',
    headerName: '명세서',
    type: 'date',
    width: 120,
    align:'center',
    editable: true,
  },
  {
    field: 'result',
    headerName: '결과',
    width: 80,
    align:'center',
    editable: true,
    renderCell: (params) => { 
      return (
        <Button variant="outlined" color="secondary">{params.value}</Button> 
      );
    },
    renderEditCell:(params) => {
      return (
        <select name="color" style={{width:'65px',textAlign:'center'}} value={params.value} onChange={(e)=>{
          // Update the value in the cell
          const updatedValue = e.target.value;
            params.api.setEditCellValue({
            id: params.id,
            field: params.field,
            value: updatedValue,
          });
        }}>
          <option value="O">O</option>
          <option value="X">X</option>
       </select>
      );
    },
  },
  {
    field: 'note',
    headerName: '비고',
    width: 150,
    align:'left',
    editable: true,
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: '저장/삭제',
    width: 100,
    cellClassName: 'actions',
    getActions: ({ id }) => {
      const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
      if (isInEditMode) {
        return [
          <GridActionsCellItem
            icon={<SaveIcon />}
            label="Save"
            sx={{
              color: 'primary.main',
            }}
            onClick={handleSaveClick(id)}
          />,
          <GridActionsCellItem
            icon={<CancelIcon />}
            label="Cancel"
            className="textPrimary"
            onClick={handleCancelClick(id)}
            color="inherit"
          />,
        ];
      }
      return [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          className="textPrimary"
          onClick={handleEditClick(id)}
          color="inherit"
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          onClick={handleDeleteClick(id)}
          color="inherit"
        />,
      ];
    },
  },
];



//download excel
const exceldown = async () => {
    try{
      const exceldata =await axiosInstance.get(`/orderboard/download`);
      // Excel 파일 생성 및 다운로드
      const wb = XLSX.utils.book_new();
      const contents = [];
      const headerStyle = {
        font: { bold: true, color: { rgb: '000000' }, name: '맑은 고딕', sz: 11 },
        //fill: { fgColor: { rgb: 'BC8F8F' } },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: { 
          left: { style: 'thin', color: { auto: 1 } }, 
          right: { style: 'thin', color: { auto: 1 } }, 
          top: { style: 'thin', color: { auto: 1 } }, 
          bottom: { style: 'thin', color: { auto: 1 } } 
        }
      }
      const contentsStyle = {
        font: { bold: false, color: { rgb: '000000' }, name: '맑은 고딕', sz: 11 },
        //fill: { fgColor: { rgb: 'BC8F8F' } },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: { 
          left: { style: 'thin', color: { auto: 1 } }, 
          right: { style: 'thin', color: { auto: 1 } }, 
          top: { style: 'thin', color: { auto: 1 } }, 
          bottom: { style: 'thin', color: { auto: 1 } } 
        }
      }


      for(let i = 0; i < exceldata.data.length; i++){
        /*
        exceldata.data[i].delivery
        exceldata.data[i].delivery_date
        exceldata.data[i].deposit
        exceldata.data[i].deposit_day
        exceldata.data[i].deposit_price
        exceldata.data[i].deposit_send
        exceldata.data[i].due_date
        exceldata.data[i].hide
        exceldata.data[i].id
        exceldata.data[i].inputdate
        exceldata.data[i].material
        exceldata.data[i].material_code
        exceldata.data[i].material_price
        exceldata.data[i].material_weight
        exceldata.data[i].note
        exceldata.data[i].order_company
        exceldata.data[i].order_company_code
        exceldata.data[i].position
        exceldata.data[i].purchaser
        exceldata.data[i].purchaser_code
        exceldata.data[i].result
        exceldata.data[i].statement
        exceldata.data[i].username
        */
        contents.push(
          [
            { v:i+1, t:'s',s:contentsStyle},
            { v:exceldata.data[i].inputdate.substring(0,19)},
            { v:exceldata.data[i].order_company},
            { v:exceldata.data[i].material},
            { v:exceldata.data[i].due_date.substring(0,10)},
            { v:exceldata.data[i].material_weight},
            { v:exceldata.data[i].material_price},
            { v:exceldata.data[i].deposit},
            { v:exceldata.data[i].material_price},
            { v:exceldata.data[i].deposit_day},
            { v:exceldata.data[i].deposit_price},
            { v:exceldata.data[i].statement},
            { v:exceldata.data[i].purchaser},
            { v:exceldata.data[i].result},
            { v:exceldata.data[i].delivery},
            { v:exceldata.data[i].delivery_date},
            { v:exceldata.data[i].note},
          ]
        )
      }
      const title = [
        { v: '번호', t:'s',s:headerStyle},
        { v: '발주시간', t:'s',s:headerStyle},
        { v: '발주업체', t:'s',s:headerStyle},
        { v: '발주원료', t:'s',s:headerStyle},
        { v: '업체요청 납품일', t:'s',s:headerStyle},
        { v: '수량', t:'s',s:headerStyle},
        { v: '단가', t:'s',s:headerStyle},
        { v: '선입여부', t:'s',s:headerStyle},
        { v: '입금일', t:'s',s:headerStyle},
        { v: '선입금액', t:'s',s:headerStyle},
        { v: '납품일', t:'s',s:headerStyle},
        { v: '거래명세서', t:'s',s:headerStyle},
        { v: '매입처', t:'s',s:headerStyle},
        { v: '납품여부', t:'s',s:headerStyle},
        { v: '납품방법', t:'s',s:headerStyle},
        { v: '납품일', t:'s',s:headerStyle},
        { v: '비고', t:'s',s:headerStyle},
      ]
      const rows = [title, ...contents];
      // 새로운 Sheet 객체 생성
      const ws = XLSX.utils.aoa_to_sheet(rows);
      // cols 속성 적용
      //ws['!cols'] = cols;
      // workbook에 추가
      XLSX.utils.book_append_sheet(wb, ws);
      // 파일 다운로드
      XLSX.writeFile(wb, `${'test'}.xlsx`);
    }catch(error){
        console.error('Error occurred while downloading Excel', error);
    }
}


  return (
  <div>      
    <div className='order_header'>
    <Link to='/Orderboards'  state={{ data: orderboardDay}} >
      <Button variant="outlined" color="secondary" sx={{height:'100%'}}>
      Back to Orderboards
      </Button>
    </Link>
    <h5>{ordersubject}</h5>
    <Button  variant="outlined" color="info" onClick={()=>windowReload()}>발주LIST</Button>
    <Button  variant="outlined" color="info" onClick={()=>getTodayOrder(today)}>오늘발주<br></br>{today}</Button>
    <Button  variant="outlined" color="info" onClick={()=>getTomorrowOrder(tomorrow)}>내일발주<br></br>{tomorrow}</Button>
    <Button  variant="outlined" color="info" onClick={()=>getTomorrowOrder(twodayafter)}>2일뒤발주<br></br>{twodayafter}</Button>
      <div>
        <Select
          labelId="demo-simple-select-label2"
          id="demo-simple-select2"
          value={searchTitle}
          label="title"
          onChange={handleSearch}
        >
          <MenuItem value={'발주처'}>발주처</MenuItem>
          <MenuItem value={'원료명'}>원료명</MenuItem>
          <MenuItem value={'구매업체'}>구매업체</MenuItem>
          <MenuItem value={'배송'}>배송</MenuItem>
          <MenuItem value={'비고'}>비고</MenuItem>
        </Select>
        <TextField 
          inputRef={searchString}
          onKeyDown={(event) => {if (event.key === 'Enter') SearchOrder(1);}}
        ></TextField>
        <Button variant="contained" color="success" sx={{height:'100%'}} onClick={()=>SearchOrder(1)}>Search!</Button>
      </div>
    </div>
    <Box
    sx={{
      minHeight:'1000px',
      width: '100%',
      '& .actions': {
        color: 'text.secondary',
      },
      '& .textPrimary': {
        color: 'text.primary',
      },
    }}
    >
    <DataGrid
      container spacing={0}
      sx={{
        fontSize:14,
        border:1,
        centerColumn:'primary.main'
      }}
      autoHeight
      rows={rows}
      columns={columnList}
      editMode="row"
      rowModesModel={rowModesModel}
      onRowModesModelChange={handleRowModesModelChange}
      onRowEditStop={handleRowEditStop}
      disableColumnSorting
      disableColumnFilter 
      hideFooter
      processRowUpdate={processRowUpdate}
    />
   </Box>
   <div style={{display:'flex',justifyContent: 'space-between'}}>
    <div style={{display:'inline-block'}}>
    <Stack spacing={1}>
      <Pagination count={orderCount} page={page} onChange={handleChange} boundaryCount={2}  variant="outlined" shape="rounded" />
    </Stack>
    </div>
    <div style={{display:'inline-block'}}>
    <Button variant="contained" color="success"  id="btn_excelDown" onClick={()=>exceldown()}>
      DonwLoad FullTable
    </Button>
    </div>
   </div>

      <form onSubmit={handleSubmit}>
        <table className='order_table'>
          <tbody>
            <tr>
              <td className='mustinput'>        
                <Autocomplete
                  freeSolo={true}
                  disablePortal
                  id="order_company_list"
                  options={order_company}
                  sx={{ width: 300,
                    fontSize:10
                   }}
                  renderInput={(params) => <TextField {...params} label="발주 업체 리스트" />}
                  value={orderInputChange}
                  onChange={(event, newValue) => {
                    checkdeposit(newValue);
                  }}
                  onInputChange={(event, newInputValue) => {
                    setOrderInputChange(newInputValue);
                  }}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                />
               </td>
               <td className='mustinput'>
                <Autocomplete
                  freeSolo={true}
                  disablePortal
                  id="material_list"
                  options={materialList}
                  sx={{ 
                    width: 400,
                    imeMode:'inactive'
                  }}
                  renderInput={(params) => <TextField {...params} label="원료 LIST" />}
                  value={materialInputChange}
                  onChange={(event, newValue) => {
                    setMaterialChange(newValue);
                  }}
                  onInputChange={(event, newInputValue) => {
                    setMaterialInputChange(newInputValue);
                  }}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                />
               </td>
               <td className='mustinput'>
                 <label>수량 <br/>
                 <input id='inputWeight' className='inputPW' type="number" step="0.001" onChange={inputWeight} value={weight}/>
                 </label> 
               </td>
               <td className='mustinput'>
                 <label>납기일<br/> <input id='inputDeliveryDate' type="date" onChange={inputDeliveryDate} value={deliveryDate} /></label>
               </td>
               <td>
                 <label>단가 <br/>
                 <input id='inputprice' className='inputPW' type="number" onChange={inputPrice} value={price}/>
                 </label> 
               </td>

               <td>
                <label>선입금 <br></br>
                  <Switch color='success' {...label} onChange={switchDeposit} checked={deposit}/>
                </label>

                  { deposit === true ? (
                    <div>
                      {depositRatio*100} % 선입금 조건 업체
                      <br></br>
                      <label>선입금 금액:VAT포함
                        <input type='number' className='inputPW' onChange={inputDepositPrice} value={depositPrice || ''} /> 
                      </label>
                      <br></br>
                      <label>입금 날짜
                        <input type='date' onChange={inputDepositDate} /> 
                      </label>
                    </div>
                     ) : (
                      <div>선입금 업체 아님</div>
                     ) }
                     </td>
               <td>
                <Autocomplete
                    freeSolo={true}
                    disablePortal
                    id="buy_company_list"
                    options={buy_company}
                    sx={{ width: 200 }}
                    renderInput={(params) => <TextField {...params} label="주문 필요한 업체" />}
                    value={buyInputChange}
                    onChange={(event, newValue) => {
                      setBuyChange(newValue);
                    }}
                    onInputChange={(event, newInputValue) => {
                      setBuyInputChange(newInputValue);
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                  />
               </td>
               <td>
                <InputLabel id="demo-simple-select-label">배송</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={delivery}
                  label="Age"
                  onChange={handleDilivery}
                >
                  <MenuItem value={'미정'}>미정</MenuItem>
                  <MenuItem value={'직송'}>직송</MenuItem>
                  <MenuItem value={'택배'}>택배</MenuItem>
                  <MenuItem value={'착불택배'}>착불택배</MenuItem>
                  <MenuItem value={'화물'}>화물</MenuItem>
                </Select>
                </td>
                <td>
                  <TextField 
                  label="비고"
                  value={textarea}
                  onChange={changeTextarea}
                  style={{minWidth:'150px',fontSize:'0.8rem'}}
                  />
                </td>
                <td align="left" style={{minWidth:'230px',fontSize:'0.8rem'}}>
                  *비고텝 <br></br>
                  1. ASAP 적을경우 ASAP LIST 에 출력 <br></br>
                  2. 재고없음 적을경우 수량 붉은색으로 표시 <br></br>
                  3. 수입후/입고후 입력시 납품일자 미표시<br></br>
                  4. 배송처:납품장소,납품처:납품장소,배송:납품장소,납품:납품장소 로 입력시 발주처➡배송처 출력
                </td>
            </tr>
            <tr>
              <td colSpan={11}> <input type="submit" value="Submit" className='ordersubmit' /> </td>
            </tr>
          </tbody>
        </table>
      </form>
  </div>
  );
}
export default Order;